function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_4576_1435)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.3517 15.3776C18.1751 12.569 18.8783 8.11297 16.7925 4.50126C15.5533 2.35372 13.5621 0.910954 11.3428 0.3125C11.1473 0.36165 4.6132 2.06314 9.00001 9.00067C17.3089 8.66583 15.3594 15.3512 15.3517 15.3776Z",
  fill: "#F6BB42"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.61904 4.00244L7.53938 4.04228C7.34548 5.28179 7.67259 6.90144 8.99997 9.00064C17.3089 8.66583 15.3593 15.3512 15.3517 15.3776C16.419 14.3158 17.1831 13.0183 17.6083 11.6208C17.6324 11.2874 18.045 4.00244 7.61904 4.00244Z",
  fill: "#4A89DC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.301392 11.3125C1.32202 15.1615 4.82935 17.9992 8.99997 17.9992C11.4796 17.9992 13.7252 16.9962 15.3528 15.3735C15.4077 15.1791 17.2012 8.67 8.99997 9.00045C5.13533 16.3633 0.320342 11.3322 0.301392 11.3125Z",
  fill: "#5D9CEC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.3517 15.3776C18.1751 12.569 18.8783 8.11297 16.7925 4.50126C15.5533 2.35372 13.5621 0.910954 11.3428 0.3125C11.1473 0.36165 4.6132 2.06314 9.00001 9.00067C17.3089 8.66583 15.3594 15.3512 15.3517 15.3776Z",
  fill: "#F6BB42"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.61904 4.00244L7.53938 4.04228C7.34548 5.28179 7.67259 6.90144 8.99997 9.00064C17.3089 8.66583 15.3593 15.3512 15.3517 15.3776C16.419 14.3158 17.1831 13.0183 17.6083 11.6208C17.6324 11.2874 18.045 4.00244 7.61904 4.00244Z",
  fill: "#4A89DC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.301392 11.3125C1.32202 15.1615 4.82935 17.9992 8.99997 17.9992C11.4796 17.9992 13.7252 16.9962 15.3528 15.3735C15.4077 15.1791 17.2012 8.67 8.99997 9.00045C5.13533 16.3633 0.320342 11.3322 0.301392 11.3125Z",
  fill: "#5D9CEC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.019 10.304L14.024 10.215C13.0479 9.4267 11.4813 8.90046 9 9.00045C5.13533 16.3633 0.320342 11.3322 0.301392 11.3125C0.687282 12.7676 1.42858 14.0777 2.42667 15.145C2.70298 15.3329 8.80583 19.3324 14.019 10.304Z",
  fill: "#F6BB42"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.3472 0.311307C7.50288 -0.729923 3.29243 0.889441 1.20722 4.50091C-0.0328246 6.64841 -0.286874 9.09451 0.304443 11.3156C0.444793 11.4601 5.18535 16.2677 9.00003 9.00032C4.55554 1.97188 11.3203 0.317636 11.3472 0.311307Z",
  fill: "#FFCE54"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.36164 12.6953L5.43607 12.7442C6.60692 12.2922 7.84564 11.1995 9 9.00067C4.55551 1.97222 11.3203 0.317984 11.3472 0.311656C9.89431 -0.0819344 8.38833 -0.0951185 6.96508 0.235575C6.66434 0.381163 0.148983 3.6663 5.36164 12.6953Z",
  fill: "#5D9CEC"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4576_1435"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  fill: "white"
})));

var SvgVolleyball = function SvgVolleyball(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVolleyball, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/volleyball.f1d8488d.svg";
export { ForwardRef as ReactComponent };